import React from "react";
import "./PaginationBar.css";

const PaginationBar = ({ totalPages, currentPage, onPageChange, totalItems, itemsPerPage }) => {
  const getPaginationItems = () => {
    const items = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(i);
      }
    } else {
      if (currentPage <= 3) {
        items.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        items.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        items.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }

    return items;
  };

  const paginationItems = getPaginationItems();
  
  // Calculate start and end items for current page
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="pagination-container">
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "16px" }}>
        {/* Page Info */}
        {totalItems > 0 && (
          <div className="pagination-info">
            <span>
              Showing {startItem} to {endItem} of {totalItems} results
            </span>
          </div>
        )}
        
        {/* Pagination Controls */}
        <nav>
          <ul className="pagination">
            {/* Previous Button */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                title="Previous page"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </button>
            </li>
            
            {/* Page Numbers */}
            {paginationItems.map((item, index) =>
              item === "..." ? (
                <li key={`ellipsis-${index}`} className="page-item">
                  <span className="pagination-ellipsis">…</span>
                </li>
              ) : (
                <li
                  key={item}
                  className={`page-item ${currentPage === item ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => onPageChange(item)}
                    title={`Go to page ${item}`}
                  >
                    {item}
                  </button>
                </li>
              )
            )}
            
            {/* Next Button */}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                title="Next page"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default PaginationBar;
